import request from '@/utils/request';
import { hasMinimumLength } from '@/utils/resultsHelper';
import {
  endpoints, tokenEndpoint, userTokenEndpoint, userTokensEndpoint,
} from '@/constants/urls';

const tokens = (filter, includeActive, includeExpired, includeSystem, page, pageSize, user) => {
  const params = {
    filter,
    page,
    pageSize,
  };

  if (includeActive !== includeExpired) {
    if (includeActive) {
      params.active = true;
    } else {
      params.inactive = true;
    }
  }

  if (includeSystem) {
    params.system = true;
  }

  const url = user ? userTokensEndpoint(user) : endpoints.TOKENS;
  return (
    request({
      url,
      params,
      method: 'GET',
    })
  );
};

const create = ({
  code, name, description, expiresOn, role, ip_range: ipRange, max_uses: MaxUses,
}, user) => {
  const data = {
    code,
    name,
    description,
    ip_range: ipRange,
    max_uses: MaxUses,
    role: { code: role },
    expires_at: expiresOn,
  };

  if (!hasMinimumLength(data.code)) {
    delete data.code;
  }

  return request({
    url: userTokensEndpoint(user),
    data,
    method: 'POST',
  });
};

const destroy = ({ code }, user) => request({
  url: user ? userTokenEndpoint(user, code) : tokenEndpoint(code),
  method: 'DELETE',
});

const disable = ({ code }, user) => request({
  url: user ? `${userTokenEndpoint(user, code)}/disable` : `${tokenEndpoint(code)}/disable`,
  method: 'PATCH',
});

const TokensService = {
  tokens,
  create,
  destroy,
  disable,
};

export default TokensService;
